export class NetworkState {
  /**
   *
   * @type {number}
   */
  counter = 0;
}
